import React from 'react';

const StepNavigation = ({ steps, currentStep }) => (
    <div className="relative flex items-center justify-evenly">
        {/* Thick Line */}
        <div className="absolute top-1/2 transform -translate-y-1/2 left-0 right-0 h-1 bg-black"></div>

        {steps.map((step, index) => (
            <div key={index} className="relative flex flex-col items-center">
                {/* Step Circle */}
                <div
                    className={`w-5 h-5 rounded-full flex items-center justify-center z-10 ${
                        index <= currentStep ? 'bg-black' : 'bg-gray-400'
                    }`}
                >
                    {index === currentStep && (
                        <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                    )}
                </div>
                {/* Step Label */}
                <div
                    className="absolute top-14 text-center text-black text-xs font-semibold sm:text-sm"
                    style={{ whiteSpace: 'nowrap' }}
                >
                    {step.label}
                </div>
            </div>
        ))}
    </div>
);

export default StepNavigation;
